import styles from './index.module.less';
import { CommonBackContent } from '../Layouts/CommonBackContent';
import { App, AutoComplete, Avatar, Button, Form, List, Modal, Skeleton, Space, Spin } from 'antd';
import { useLocation, useToggle } from 'react-use';
import { useUserProvider } from '@/context/UserProvider';
import CardItem from '../Common/CardItem';
import { useRouter } from 'next/router';
import { useConfigProvider } from '@/context/ConfigProvider';
import {
  addInsMonitor,
  fetchInsMonitorList,
  fetchInsMonitorSearch,
  fetchMonitorUnaddData,
  orderResumeRequest,
  orderSubsQueryRequest,
  removeInsMonitor,
  singleBuyRequest,
} from '@/lib/service';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { InsAccountModel, InsMonitorModel, OrderModel, SingleOrderTimesModel, UnAddAccountModel } from '@/types/home';
import Image from 'next/image';
import TrackDisabledItem from './TrackDisabledItem';
import { CloseCircleOutlined, MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { changeDate, extractInstagramUsername, isInstagramProfileURL } from '@/shared/utils';
import { ga_logEvent } from '@/shared/ga';
import { EventName } from '@/shared/event-types';
import CommonSimpleModal from '../Common/CommonSimpleModal';
import AddAccountContent from './AddAccountContent';
import ActiveAccountModal from '@/components/ActiveAccountModal/index';
import dayjs from 'dayjs';
import { debounce, forEach } from 'lodash';
import UserDashboard from './UserDashboard';
import { getCurrencyInfo } from '@/components/Plan/LangCurrencyEnum';
import UnlockModalContent from '../Common/UnlockModalContent';
import Cookies from 'js-cookie';
import TopSearchContent from '../LandingPage/TopSearch';
import Link from 'next/link';
import { cn } from '@/lib/utils';
import ExampleReportContent from './ExampleReportContent';
import RecentSearchReportContent, {
  hasRecentSearchReportContent,
  InsAccountModelToInsMonitorModel,
  removeRecentSearchReportContentByMediaNames,
  setRecentSearchReportContent,
} from './RecentSearchReportContent';
import useStoryPremium from '@/lib/hooks/isPremium/useStoryPremium';
import useMainPremium from '@/lib/hooks/isPremium/useMainPremium';
// import { getAuth, onAuthStateChanged, User } from 'firebase/auth';

const ONLY_ONE_USER = 1;

// TODO: 提取搜索账号的逻辑，与首页及其他页面共用
const DetailContent = ({ data }: { data: any }) => {
  const location = useLocation();

  const [open, toggle] = useToggle(false);
  const [hasAccount, setHasAccount] = useToggle(false);
  const [openBuy, setOpenBuy] = useToggle(false);
  const { accountList, onInitAccountList, isLogin, onChangedLoginView, onOpenLoginModal } = useUserProvider();
  const router = useRouter();
  const { addNewAccount } = router.query;
  const { t } = useTranslation('common');
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [initLoading, setInitLoading] = useState(true);
  const { message } = App.useApp();
  const [accountModel, setAccountModel] = useState<InsAccountModel>();
  const [openDelete, toggleDelete] = useToggle(false);
  const [selectedAccount, setSelectedAccount] = useState<InsMonitorModel>();
  const { isBlogWeb, isMobile } = useConfigProvider();
  const [selectModel, setSelectModel] = useState<InsMonitorModel>();
  const [buyLoading, setBuyLoading] = useState(false);
  const [weekCount, setWeekCount] = useState(1);
  const [showBuyBanner, setShowBuyBanner] = useState(false);
  const [showPlan, setShowPlan] = useState<string>(undefined);
  const [selectOrderModel, setSelectOrderModel] = useState<SingleOrderTimesModel>();

  const [openPrivateAccount, setOpenPrivateAccount] = useState<any>(null);
  const [unAddAccountList, setUnAddAccountList] = useState<UnAddAccountModel[]>([]);
  const [currentUnAddAccount, setCurrentUnAddAccount] = useState<UnAddAccountModel>(null);
  const [isClient, setIsClient] = useState(false);
  const [isBtnAble, setIsBtnAble] = useState(true);
  const [openUnLock, setOpenUnLock] = useState(false);

  // 购买弹窗
  const [isModalOpen, setisModalOpen] = useState(false);
  const [selectRow, setSelectRow] = useState({});

  const [userData, setUserData] = useState<InsAccountModel[]>([]);
  const [inputOpen, setInputOpen] = useState(false);
  const autoRef = useRef(null);
  const [browserLanguage, setBrowserLanguage] = useState<string | null>(null);
  const { isPremium: isStoryPremium } = useStoryPremium();
  const { isPremium: isMainPremium } = useMainPremium();

  useEffect(() => {
    // 检查 navigator 对象是否存在于客户端
    if (typeof window !== 'undefined' && navigator.language) {
      // 获取浏览器的首选语言
      const browserLanguage = navigator.language;
      const prefix = browserLanguage.split('-')[0];
      // 设置语言前缀
      setBrowserLanguage(prefix);
    }
  }, []);
  const currencyInfo = getCurrencyInfo(browserLanguage);

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    if (isClient && addNewAccount != undefined) {
      if (unAddAccountList?.length > 0) {
        let tempUnAddAccountModel: UnAddAccountModel = unAddAccountList[0];
        unAddAccountList.forEach((item) => {
          if (dayjs(tempUnAddAccountModel?.sub_begin_time) > dayjs(item?.sub_begin_time)) {
            tempUnAddAccountModel = item;
          }
        });
        setCurrentUnAddAccount(tempUnAddAccountModel);
      }
      accountNameSearchRequest(`${addNewAccount}`);
    }
  }, [addNewAccount, unAddAccountList, isClient]);

  const orderSubscriteRequest = async (weeks?: number, identification?: any) => {
    if (!isLogin) {
      onChangedLoginView(false);
      onOpenLoginModal(true);
      return;
    }

    if (weekCount > selectOrderModel?.can_buy_week) {
      return;
    }

    if (buyLoading) {
      return;
    }
    setBuyLoading(true);

    const res = await singleBuyRequest(browserLanguage ?? 'en', weeks, identification);
    if (res.code === 0) {
      ga_logEvent(EventName.Buy_Past_Report_Request_Success);
      ga_logEvent(EventName.begin_checkout, {
        currency: 'USD',
        items: [
          {
            item_id: res?.data?.order_id,
            item_name: 'buy post',
            quantity: weeks,
          },
        ],
      });
    } else {
      ga_logEvent(EventName.Buy_Past_Report_Request_Fail);
      message.error(res.message);
    }
    setBuyLoading(false);
  };

  const loadScripePay = async (orderModel: OrderModel) => {
    window.open(orderModel?.pay_link, '_self');
  };

  useEffect(() => {
    return () => {
      if (isBlogWeb) {
        router.push('/instagram-tracking-blog');
      }
    };
  }, [isBlogWeb]);

  const onAddCurrentAccount = () => {
    setHasAccount(false);
    toggle(true);
  };

  // 跳转至未解锁报告页
  const navigateToNotActiveReport = (mediaName: string) => {
    router.push(`/analytics/not-active/${mediaName}`);
  };

  const accountNameSearchRequest = (accountName?: string) => {
    setLoading(true);
    setIsBtnAble(false);
    fetchInsMonitorSearch(accountName, router.locale)
      .then((res) => {
        setLoading(false);

        setTimeout(() => {
          setIsBtnAble(true);
        }, 1500);

        if (res.code == 0 && res.data?.length > 0) {
          const data = res.data.filter((item) => item.media_name === accountName);
          if (!data.length || res.data[0]?.is_private === 2) {
            showInvalidNameAlert();
            return;
          }

          // 如果是私密账号，显示弹窗
          if (data[0]?.is_private === 0) {
            // 如果是正常账号，跳转至未解锁报告页
            navigateToNotActiveReport(data[0]?.media_name);
          } else {
            // 如果是私密账号，显示弹窗
            setAccountModel(data[0]);
            setHasAccount(true);
            toggle(true);
          }
        } else if (res?.code === 20001) {
          setOpenPrivateAccount({
            title: t('OopsPrivateProfileDetected'),
            desc: (
              <>
                <div style={{ marginBottom: '24px' }}>{t('ThisInstagramAccountIsPrivate_Desc')}</div>
                <UserDashboard {...accountModel} />
              </>
            ),
            btnTitle: t('TRYAGAIN'),
          });
          toggle(false);
          return;
        } else if (res?.code === 20002) {
          showInvalidNameAlert();
          return;
        } else {
          message.error(res.message);
        }
      })
      .catch((error) => {
        setLoading(false);
        message.error(error.message);
        setIsBtnAble(true);
      });
  };

  const onDeleteFinish = () => {
    setDeleteLoading(true);
    removeInsMonitor(selectedAccount.monitor_id, router.locale)
      .then((res) => {
        toggleDelete(false);
        if (res.code == 0) {
          fetchList();
        } else {
          message.error(res.message);
        }
        setDeleteLoading(false);
      })
      .catch((error) => {
        setDeleteLoading(false);
        message.error(error.message);
      });
  };

  const fetchList = async () => {
    setInitLoading(true);
    const monitorList = await fetchInsMonitorList(undefined, {
      isPremium: isStoryPremium,
      bizFuncName: 'stories_viewer',
    });
    if (monitorList.code === 0) {
      onInitAccountList(monitorList.data);
    } else if (monitorList.code === 40001) {
      router.replace('/');
    } else {
      message.error(monitorList.message);
    }
    setInitLoading(false);
  };

  const onWeeksChange = (num: number) => {
    const tempNum = num + weekCount;
    if (tempNum >= 36) {
      setWeekCount(36);
    } else if (tempNum <= 1) {
      setWeekCount(1);
    } else {
      setWeekCount(tempNum);
    }
  };

  const loadSubList = () => {
    orderSubsQueryRequest('main', router.locale)
      .then((res) => {
        if (res.code === 0) {
          // setOrderList(res.data)
          const templist = (res?.data ?? []).filter((item) => {
            return item?.status === 'expire';
          });
          setShowBuyBanner(templist?.length > 0);
        } else {
          setShowBuyBanner(false);
        }
      })
      .catch((error) => {
        setShowBuyBanner(false);
      });
  };

  const onMonitorUnaddData = () => {
    fetchMonitorUnaddData(router.locale).then((res) => {
      setUnAddAccountList(res?.data ?? []);
    });
  };

  const beforeInitRecentSearchReportContent = useCallback(() => {
    removeRecentSearchReportContentByMediaNames(accountList.map((item) => item.media_name));
  }, [accountList]);

  useEffect(() => {
    // return () => {
    if (isBlogWeb) {
      return;
    }
    if (!isLogin) {
      onInitAccountList([]);
      setUnAddAccountList([]);
      setInitLoading(false);
      return;
    }
    fetchList();
    setTimeout(() => {
      loadSubList();
    }, 100);
    setTimeout(() => {
      onMonitorUnaddData();
    }, 100);
    // }
  }, [isLogin]);

  const onResumeAction = (subs_id: any, monitor_id: any) => {
    orderResumeRequest(subs_id, router.locale, '/dashboard?dashboard_type=track').then((res) => {
      if (res?.code === 0) {
        if (res?.data?.need_pay && res?.data?.pay_link) {
          loadScripePay(res?.data);
          return;
        }

        message.success(t('Restore purchase successfully'));
        fetchList();
      } else if (res?.code === 21000) {
        router.push(`/plan?last_subs_id=${subs_id}&monitor_id=${monitor_id}&type=1`);
      } else {
        message.error(res?.message);
      }
    });
  };

  const emptyContainer = () => {
    return (
      <div className={styles.emptyContainer}>
        {[1, 2, 3].map((_, index) => {
          return (
            <div className={styles.content} key={index}>
              <Skeleton.Image active />
              <Skeleton active />
            </div>
          );
        })}
      </div>
    );
  };

  const contentContainer = (unAddAccountList: UnAddAccountModel[]) => {
    return (
      <div className={styles.content}>
        <ActiveAccountModal
          isModalOpen={isModalOpen}
          routerInfo={selectRow}
          closeFn={() => {
            setisModalOpen(false);
          }}
        />
        <div className="h-14 max-md:h-7"></div>

        {showBuyBanner && <TrackDisabledItem />}

        {/* 最近搜索，未解锁账户报告，不能与已订阅账户重叠 */}
        {isLogin && (
          <RecentSearchReportContent
            beforeInit={beforeInitRecentSearchReportContent}
            unAddAccountList={unAddAccountList}
            onAddAccountSuccess={() => {
              fetchList();
              onMonitorUnaddData();
            }}
          />
        )}

        {/* 已订阅账户报告 */}
        {accountList?.length > 0 ? (
          <List>
            {accountList.map((item, index) => {
              return (
                <CardItem
                  data={item}
                  key={index}
                  onClick={(isFromSeeAnalytics, data) => {
                    if (data) {
                      router.push(
                        `/analytics/${item?.identification}?name=${item?.media_name}&identification=${item?.identification}&avatar=${item?.avatar}`
                      );
                      if (isFromSeeAnalytics) {
                        ga_logEvent(EventName.dashboard_See_Analytics);
                      }
                    }
                  }}
                  onActionClick={(isUpgrade, data) => {
                    if (isUpgrade) {
                      router.push(
                        `/plan?last_subs_id=${item?.subs_id}&last_item_id=${item?.item_id}&monitor_id=${item?.monitor_id}&type=1`
                      );
                    } else {
                      onResumeAction(item?.subs_id, item?.monitor_id);
                    }
                  }}
                  onBuyPostClick={(item) => {
                    setSelectRow(item);
                    setisModalOpen(true);
                    if (isLogin) {
                      ga_logEvent(EventName.dashboard_Buy_past_reports);
                    }
                  }}
                />
              );
            })}
          </List>
        ) : (
          <div className={cn(styles.onAccountContainer, { hidden: hasSearchedOrSubscribed() })}>
            <Image
              src="/images/report/empty-ground-icon.webp"
              alt="image"
              width={500}
              height={300}
              className={styles.groundImage}
            />
          </div>
        )}
      </div>
    );
  };

  const tooltip = () => {
    return (
      <div
        style={{
          overflow: 'hidden',
          border: '1px solid var(--app-text-30-color)',
          borderRadius: '10px',
        }}
      >
        <Image
          src={'/images/report/example-icon.webp'}
          width={500}
          height={185}
          layout="responsive"
          alt={'icon'}
          style={{ width: '100%', aspectRatio: '500/185', objectFit: 'contain' }}
        />
      </div>
    );
  };

  const debounceFetcher = (value: string) => {
    setLoading(true);
    setIsBtnAble(false);
    fetchInsMonitorSearch(value, router.locale, { isPremium: isMainPremium, bizFuncName: 'main' })
      .then((res) => {
        setLoading(false);
        setIsBtnAble(true);
        if (res.code == 0 && res.data?.length > 0) {
          setInputOpen(true);
          autoRef.current?.focus();

          let tempData: InsAccountModel;
          forEach(res.data, (item) => {
            if (item.media_name === value) {
              tempData = item;
            }
          });
          if (tempData !== undefined) {
            setUserData([]);
            if (tempData?.is_private === 2) {
              showInvalidNameAlert();
              return;
            } else if (tempData?.is_private === 0) {
              // 如果是正常账号，且不是在弹窗中搜索的
              if (!open) {
                // 保存到最近未解锁报告列表
                setRecentSearchReportContent(InsAccountModelToInsMonitorModel([tempData]));
                // 跳转至未解锁报告页
                navigateToNotActiveReport(tempData?.media_name);
              } else {
                // 如果正在添加未添加账户，则使用原有流程
                setHasAccount(true);
                setAccountModel(tempData);
              }
            } else {
              // 如果是私密账号，显示弹窗
              setAccountModel(tempData);
              setHasAccount(true);
              toggle(true);
            }
          } else {
            if (open) {
              // 如果弹窗打开，则使用原有流程，不处理
              setUserData(res.data);
            } else {
              // 跳过阶段一，暂时忽略多个用户的情况，未精确匹配到用户时，直接提示无效
              setUserData([]);
              showInvalidNameAlert();
              return;
            }
          }
        } else if (res?.code === 10001) {
          showInvalidNameAlert();
          return;
        } else {
          message.error(res.message);
        }
      })
      .catch((error) => {
        setLoading(false);
        message.error(error.message);
        setIsBtnAble(true);
      });
  };

  const showInvalidNameAlert = () => {
    setOpenPrivateAccount({
      title: t('Invalid Instagram Username'),
      desc: t('The username you entered is not valid. Please check the username and try again.'),
      btnTitle: t('TRYAGAIN'),
    });
    toggle(false);
  };

  const updateQueryParam = (key: string, value: string) => {
    // 获取当前查询参数
    const newQuery = { ...router.query, [key]: value };

    // 使用 pushState 更新 URL，且不刷新页面
    router.push(
      {
        pathname: router.pathname, // 保持当前路径
        query: newQuery, // 更新查询参数
      },
      undefined,
      { shallow: true }
    ); // shallow: true 确保不触发页面刷新
  };

  const [searchStr, setSearchStr] = useState((router.query.accountName as string) || '');

  const onValueChanged = (e?: string) => {
    setSearchStr(e ?? '');
  };

  // 搜索
  const onSearch = useCallback(
    debounce((value: string) => {
      if (!value) {
        message.error(t('Please enter the insert link or username'));
        return;
      }
      // 处理输入的账户名，去除前后空格，并转换为小写
      value = (value || '').trim().toLowerCase();

      if (!value || isInstagramProfileURL(value)) {
        setUserData([]);
        return;
      }
      autoRef.current?.blur();
      setUserData([]);
      debounceFetcher(value);

      updateQueryParam('accountName', value);
    }, 500),
    [open]
  );

  // 清除内容
  const onClear = () => {
    setAccountModel(undefined);
    setUserData([]);
  };

  // 选择user
  const onSelect = (val: string) => {
    setInputOpen(false);
    setHasAccount(true);
    if (userData.length === ONLY_ONE_USER) {
      if (userData[0]?.is_private === 2) {
        setHasAccount(false);
        showInvalidNameAlert();
        return;
      }
      onFinish({ accountName: val });
      return;
    }
    setUserData(userData.filter((user) => user.media_name === val));

    const tempData = userData.find((user) => user.media_name === val);
    if (tempData?.is_private === 2) {
      setHasAccount(false);
      showInvalidNameAlert();
      return;
    } else {
      setAccountModel(tempData);
    }
  };

  const isAuthLoading = useMemo(() => {
    return typeof window === 'undefined' || router?.query?.authLoading === 'true';
  }, [router?.query?.authLoading]);

  // 用户添加过账号或订阅
  const hasAddAccountOrSubscribe = useMemo(() => {
    return isLogin && (accountList.length > 0 || unAddAccountList.length > 0);
  }, [isLogin, accountList, unAddAccountList]);

  // 是否搜索过或订阅过
  const hasSearchedOrSubscribed = useCallback(() => {
    return isLogin && (hasRecentSearchReportContent() || hasAddAccountOrSubscribe);
  }, [isLogin, hasRecentSearchReportContent, hasAddAccountOrSubscribe]);

  // 提交搜索
  const onFinish = ({ accountName }: { accountName: string }) => {
    if (isAuthLoading || Cookies.get('authLoading') === 'true') {
      return;
    }

    // 阶段一还未获取账户信息
    if (!hasAccount) {
      // 处理输入的账户名，去除前后空格，并转换为小写
      accountName = (accountName || '').trim().toLowerCase();
      if (isInstagramProfileURL(accountName)) {
        ga_logEvent(EventName.dashboard_Check);
        const username = extractInstagramUsername(accountName);
        // console.log(username);

        accountNameSearchRequest(username);
      } else {
        onSearch(accountName);
      }
      return;
    }

    // 阶段二，如果账户是私密的，关闭弹窗
    if (accountModel?.is_private !== 0) {
      setAccountModel(null);
      setHasAccount(false);
      toggle(false);
      return;
    }

    // 正常账户
    if (hasAccount) {
      ga_logEvent(EventName.dashboard_Add_new_account);

      if (isLogin) {
        if (currentUnAddAccount === null) {
          setOpenUnLock(true);
          // setShowPlan(
          //   t(
          //     `Unlock a slot to start tracking. Gain deeper insights into their likes, follows, suspected accounts on other platforms, AI insights, and more.`,
          //   ),
          // );
          return;
        }

        setLoading(true);
        addInsMonitor(
          accountModel.media_name,
          accountModel.profile_pic_url,
          accountModel.media_url,
          currentUnAddAccount?.subs_id,
          router.locale
        )
          .then((res) => {
            setLoading(false);
            if (res.code === 0) {
              fetchList();
              toggle(false);
              ga_logEvent(EventName.Add_Account_Request_Success);
              setCurrentUnAddAccount(null);

              const newUrl = location.pathname;
              window.history.replaceState({}, document.title, newUrl);

              onMonitorUnaddData();
              // Reload the page
              // window.location.reload();
            } else if (res?.code === 20000) {
              setShowPlan(res?.message);
              toggle(false);
              return;
            } else {
              message.error(res.message);
            }
          })
          .catch((error) => {
            setLoading(false);
            message.error(error.message);
          });
      } else {
        onChangedLoginView(false);
        onOpenLoginModal(true);
      }
    }
  };

  const modalContent = () => {
    return (
      <Modal
        className={styles.modalContainer}
        open={open}
        onCancel={() => {
          toggle(false);
          onClear();
        }}
        destroyOnHidden={true}
      >
        <Form
          name="normal_edit_form"
          layout="vertical"
          className={styles.formContent}
          initialValues={{ accountName: router.query.accountName }}
          onFinish={onFinish}
          style={{ padding: '20px 24px' }}
          validateTrigger="onSubmit"
        >
          <div className={styles.titleContainer}>
            {accountModel?.is_private ? t('OopsPrivateProfileDetected') : t('ADD new account')}
          </div>
          <Form.Item>
            <div className={styles.desc}>
              {hasAccount ? (
                accountModel?.is_private ? (
                  t('ThisInstagramAccountIsPrivate_Desc')
                ) : (
                  t('AddToYourTrackingListToSeeTheirLikes_Desc')
                )
              ) : (
                <div>
                  <p style={{ color: '#333', marginBottom: '8px' }}>
                    {t('No one will ever know. Get the answers you need:')}
                  </p>
                  <p>{t('🔗 See their closest connections')}</p>
                  <p>{t('👁 Track new follows and unfollows')}</p>
                  <p>{t('🔍 Access in-depth activity reports')}</p>
                </div>
              )}
            </div>
          </Form.Item>
          {!hasAccount && <Form.Item>{tooltip()}</Form.Item>}
          {hasAccount ? (
            <Form.Item className="no-asterisk">
              <UserDashboard {...accountModel} />
            </Form.Item>
          ) : (
            <Form.Item
              name="accountName"
              rules={[{ required: true, message: t('PleaseInputAnAccount') }]}
              className="no-asterisk"
            >
              <AutoComplete
                ref={autoRef}
                open={inputOpen}
                options={(userData || []).map((d) => ({
                  value: d.media_name,
                  label: (
                    <Space>
                      <Avatar src={d.profile_pic_url} /> {d.media_name}
                    </Space>
                  ),
                }))}
                style={{ pointerEvents: loading ? 'none' : 'auto' }}
                onClear={onClear}
                onSelect={onSelect}
                onBlur={() => setInputOpen(false)}
                onClick={() => {
                  if (!inputOpen) setInputOpen(true);
                }}
                className={styles.inputItem}
                placeholder={t('EnterTheAccountUsernameAsInTheExampleAbove')}
                allowClear={{ clearIcon: <CloseCircleOutlined /> }}
                notFoundContent={loading ? <Spin size="small" /> : null}
              />
            </Form.Item>
          )}

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className={styles.bottomButton}
              style={{ background: isBtnAble ? '' : '#999' }}
              loading={loading}
            >
              {hasAccount ? (accountModel?.is_private ? t('TRYAGAIN') : t('ADD ACCOUNT')) : t('CHECK')}
            </Button>
            <p style={{ color: 'var(--app-text-30-color)', marginTop: '10px' }}>
              {t('Note: Only public accounts can be tracked.')}
            </p>
          </Form.Item>
        </Form>
      </Modal>
    );
  };

  const deleteModal = () => (
    <Modal
      className={styles.modalContainer}
      open={openDelete}
      onCancel={() => {
        toggleDelete(false);
        setSelectedAccount(undefined);
      }}
      destroyOnHidden={true}
    >
      <Form
        name="normal_delete_form"
        layout="vertical"
        className={styles.deleteContent}
        onFinish={onDeleteFinish}
        style={{ padding: '20px 24px' }}
      >
        <div className={styles.titleContainer} style={{ textAlign: 'center' }}>
          {t('You really want to delete this account')}
        </div>
        <Form.Item>
          <p className={styles.desc}>{t("We'll stop tracking once you delete the account")}</p>
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" className={styles.bottomButton} loading={deleteLoading}>
            {t('Yes_Delete')}
          </Button>
        </Form.Item>
        <Form.Item>
          <Button className={styles.bottomButton} onClick={() => toggleDelete(false)}>
            {t('NotNow_Thanks')}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );

  const buyModalContent = () => {
    return (
      <Modal
        className={styles.modalContainer}
        open={openBuy}
        onCancel={() => {
          setWeekCount(1);
          setOpenBuy(false);
        }}
        destroyOnHidden={true}
      >
        <Form
          name="normal_edit_form"
          layout="vertical"
          className={styles.formContent}
          onFinish={() => {
            orderSubscriteRequest(weekCount, selectModel?.identification);
            ga_logEvent(EventName.dashboard_Buy_past_reports_btn);
          }}
          style={{ padding: '20px 24px' }}
        >
          <div className={styles.titleContainer}>{t('RequestRetrospectiveDatafor')}</div>

          <Form.Item className="no-asterisk">
            <div className={styles.itemContent}>
              <Image
                src={selectModel?.avatar}
                width={60}
                height={60}
                alt={'account icon'}
                loading="lazy"
                className={styles.imgContainer}
              />
              <div>
                <h3>{selectModel?.media_name}</h3>
                <span>{`${t('Tracking started on')} ${changeDate(
                  selectModel?.post_report_date || selectModel?.tracking_date,
                  'YYYY-MM-DD',
                  weekCount * 7
                )}`}</span>
              </div>
            </div>
          </Form.Item>

          <Form.Item>
            <div className={styles.desc}>{t('SelectTheNumberOfWeeksForWhichYouNeedHistoricalActivityData_Desc')}</div>
          </Form.Item>

          <Form.Item>
            <div className={styles.weekContainer}>
              <div className={styles.title}>{t('HowManyWeeksDoYouWantToAdd')}</div>

              <div className={styles.weekContent}>
                <MinusCircleOutlined
                  className={classNames(styles.minus, weekCount <= 1 ? styles.disAble : '')}
                  onClick={() => onWeeksChange(-1)}
                />

                <div className={styles.descContainer}>
                  <div className={styles.weekStyle}>{`${weekCount} ${t('Week')}`}</div>
                  <div className={styles.dateStyle}>{t('you will get reports for')}</div>
                  <div className={styles.dateStyle}>{`${changeDate(
                    selectModel?.post_report_date || selectModel?.tracking_date,
                    'YYYY-MM-DD',
                    weekCount * 7
                  )} - ${changeDate(selectModel?.post_report_date || selectModel?.tracking_date, 'YYYY-MM-DD')}`}</div>
                </div>

                <PlusCircleOutlined
                  className={classNames(styles.plus, weekCount > selectOrderModel?.can_buy_week ? styles.disAble : '')}
                  onClick={() => {
                    if (weekCount <= selectOrderModel?.can_buy_week) {
                      onWeeksChange(1);
                    }
                  }}
                />
              </div>
            </div>
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                background: selectOrderModel?.can_buy_week < weekCount ? '#999' : `var(--app-primary-color)`,
              }}
              className={styles.bottomButton}
              loading={buyLoading}
            >
              {`${currencyInfo.symbol}${(currencyInfo.price * weekCount).toFixed(2)}`}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    );
  };

  const planModalContent = () => {
    return (
      <Modal
        className={styles.plamModalContainer}
        styles={{ body: { padding: '0px' } }}
        open={showPlan != undefined}
        onCancel={() => {
          setShowPlan(undefined);
        }}
        destroyOnHidden={true}
        footer={null}
      >
        <div
          // name="normal_edit_form"
          // layout="vertical"
          className={styles.formContent}
          style={{
            padding: '20px 24px 70px 20px',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: '100% 100%',
            // backgroundImage: `url('/images/plan/plan_alert_bg.webp')`,
            backgroundImage: `url('https://res-front.pumpsoul.com/ins-prod/image/plan_alert_bg.webp')`,
            borderRadius: '10px',
          }}
        >
          <div className={styles.titleContainer}>{t('One Step Away from Full Access')}</div>
          <div className={styles.desc} style={{ marginBottom: '60px' }}>
            {showPlan}
          </div>

          <Button
            className={styles.bottomButton}
            style={{
              color: `#FFF`,
              background: `linear-gradient( 180deg, #725CFF 0%, rgba(141,131,255,0.8) 100%)`,
            }}
            onClick={() => {
              router.push(
                `/plan?media_name=${accountModel.media_name}&avatar=${accountModel.profile_pic_url}&media_url=${accountModel.media_url}`
              );
              setShowPlan(undefined);
            }}
          >
            {t('Unlock Now')}
          </Button>
        </div>
      </Modal>
    );
  };

  if (isBlogWeb) {
    return <></>;
  }
  if (!isClient) {
    return null;
  }
  return (
    <CommonBackContent style={{ overflowX: 'unset' }}>
      <TopSearchContent
        topInfo={{
          title: ` ${t('Social Insights')} `,
          titleStyle: { marginTop: 32, color: '#0c0c0c' },
          desc: (
            <>
              <span className="text-[#0C0C0C] font-bold">{t('Add an Account to Start Tracking Now!')}</span>{' '}
              <span>{t('Monitor likes, follows, and interactions privately.')}</span>{' '}
              <span>{t('Curious about our insights?')}</span>{' '}
              <span>
                {t('View a sample report')}{' '}
                {
                  <Link className="text-[#725CFF]" href="/instagram-tracking-example">
                    {t('here')}
                  </Link>
                }
                {'!'}
              </span>
            </>
          ),
          descStyle: {
            display: hasSearchedOrSubscribed() ? 'none' : 'block',
            fontWeight: 'normal',
            fontSize: '18px',
          },
          tags: [
            t(`<p>Find the Truth</p>`),
            t(`<p>Rich <span style='color:#725CFF'>Data</span></p>`),
            t(`<p><span style='color:#725CFF'>AI</span>-Powered</p>`),
            t(`<p>100% <span style='color:#725CFF'>Anonymous</span></p>`),
          ],
          tagsStyle: hasSearchedOrSubscribed() ? { display: 'none' } : {},
        }}
        showSearchBtnWithFullWidth
        btnPlaceholder={t('ADD ACCOUNT')}
        displayTagsAndMiddleContentBelowSearchBox
        middleContent={
          <div
            className={cn('mt-10 flex justify-center items-center gap-1', {
              hidden: hasSearchedOrSubscribed(),
            })}
          >
            <Image src={'/images/home/home_users_icon.webp'} alt="home users icon" width={60} height={24} />

            <span style={{ fontWeight: 'bold' }}>{`50,000+`}</span>
            <span className="max-md:text-[0.875rem]" style={{ color: 'rgba(12, 12, 12, 0.60)' }}>
              {t('users repeatedly use our service')}
            </span>
          </div>
        }
        loading={loading}
        searchVal={searchStr}
        onSearchClick={onSearch}
        onValueChanged={onValueChanged}
      />
      {/* 未添加账户 */}
      {(unAddAccountList ?? []).map((item, index) => {
        return (
          <AddAccountContent
            key={`${item?.subs_id}-${index}`}
            item={item}
            onAddAccountClick={(item) => {
              setCurrentUnAddAccount(item);
              onAddCurrentAccount();
            }}
          />
        );
      })}

      {initLoading && accountList.length == 0 ? emptyContainer() : contentContainer(unAddAccountList || [])}

      {/* 示例账户报告 */}
      {hasSearchedOrSubscribed() && <ExampleReportContent />}

      {modalContent()}
      {deleteModal()}
      {buyModalContent()}
      {planModalContent()}

      {openUnLock && (
        <UnlockModalContent
          logo={accountModel?.profile_pic_url}
          name={accountModel?.media_name}
          open={openUnLock}
          onClose={(isOk?: boolean) => {
            if (isOk) {
              router.push(
                `/plan?media_name=${accountModel.media_name}&avatar=${accountModel.profile_pic_url}&media_url=${accountModel.media_url}`
              );
            }
            setOpenUnLock(false);
          }}
        />
      )}

      <CommonSimpleModal
        open={openPrivateAccount !== null}
        title={openPrivateAccount?.title}
        desc={openPrivateAccount?.desc}
        btnTitle={openPrivateAccount?.btnTitle}
        closeAction={(isOk: boolean) => {
          setOpenPrivateAccount(null);
          if (isOk) {
            setHasAccount(false);
            if (open) {
              // 如果正在添加未添加账户，则重新打开添加账号弹窗
              toggle(true);
            }
            // 否则，阶段一跳过，不处理
          }
        }}
      />
    </CommonBackContent>
  );
};

const DashboardContent = ({ data }: { data: any }) => {
  return <DetailContent data={data} />;
};

export default DashboardContent;
